import { RootState } from '../../../app/store';
import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit"

export interface loginState {
    email: string,
    password: string,
}

const initialState: loginState = {
    email: "",
    password: "",
}

export const LoginSlice = createSlice({
    name: "Login",
    initialState,
    reducers: {
        setEmail: (state, action: PayloadAction<string>) => {
            state.email = action.payload;
        },
        setPassword: (state, action: PayloadAction<string>) => {
            state.password = action.payload;
        },
    }
});

export const loginSelector = createSelector(
    (state: RootState) => state.login,
    (data) => data
);

export const { setEmail, setPassword } = LoginSlice.actions;

export default LoginSlice.reducer;